<template>
  <div class="container mt-5">

    <script v-if="price > 0" type="application/ld+json">
    {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": {{ JSON.stringify(product.title) }},
      "image": [
        "{{ img(product.image) }}"
      ],
      "description": {{ JSON.stringify(product.description) }},
      "brand": {
        "@type": "Thing",
        "name": "İsmailağa Derneği"
      },
      "offers": {
        "@type": "Offer",
        "Price": "{{ price }}",
        "priceCurrency": "TRY",
        "url": "https://bagis.ismailagadernegi.org.tr/{{ $route.params.id }}",
        "seller": {
          "@type": "Organization",
          "name": "İsmailağa Derneği"
        }
      }
    }
    </script>

    <Loader v-if="loading" />
    <div v-else class="row">
      <div class="Donation_detail col-md-9">
        <div class="Donation_detail__hero">
          <div class="Donation_detail__hero--img" :title="product.title">
            <img :src="img(product.image)" alt />
          </div>
          <div class="Donation_detail__hero--footer"
            v-if="product.web_visible === 1">
            <div class="Donation_detail__hero--input" v-if="!product.redirect_url">
              <input type="text" class="input" :disabled="product.changeable == 0" v-model="price" />
              <span>₺</span>
            </div>
            <div class="Donation_detail__hero--button">
              <button class="button button__red w-100" style="border-radius:4px"
                v-if="product.redirect_url" @click="redirect(product)">
                BAĞIŞ YAP
              </button>
              <button class="button button__red w-100" v-else @click="donate">BAĞIŞ YAP</button>
            </div>
          </div>
        </div>

        <div class="Donation_detail__title mb-3">{{product.title}}</div>
        <div class="Donation_detail__short-desc">{{product.description}}</div>

        <div class="line my-5"></div>
        <div class="Donation_detail__description" v-html="product.content"></div>

        <div class="Donation_detail__other">
          <div class="Donation_detail__other--title mb-5">
            <span class="red">Benzer</span>
            <span class="black">Bağışlar</span>
          </div>
          <div class="line my-4"></div>
          <div class="Donation_detail__other--donations">
            <!-- will change later -->
            <div class="row">
              <donation-item
                class="mb-5 col-12 w-100"
                v-for="(product) in randomProducts"
                :product="product"
                :key="product.id"
              />
            </div>
            <!-- will change later -->
          </div>
        </div>
        <div class="Donation_detail__footer">
          <img src="@/assets/img/new-ssl.png" alt />
        </div>
      </div>
      <div class="col-md-3 px-0">
        <cart />
        <div class="Cart__logos">
          <img src="@/assets/img/card-logos.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Cart from '@/components/Cart.vue'
import DonationItem from '@/components/DonationItem'

export default {
  name: 'DonationDetail',
  metaInfo() {
    if (this.loading) return {}
    return {
      title: `${this.product.title} - İsmailağa Derneği`,
      meta: [
        {
          name: 'description',
          content: this.product.description
        },
        {
          name: 'og:url',
          content: `http://bagis.ismailagadernegi.org.tr${this.$route.fullPath}`
        },
        {
          name: 'og:image',
          content: this.img(this.product.image),
          itemprop: 'image'
        },
        {
          name: 'og:title',
          content: this.product.title
        },
        {
          name: 'twitter:description',
          content: this.product.description
        },
        {
          name: 'twitter:image',
          content: this.img(this.product.image)
        },
        {
          name: 'twiiter:title',
          content: this.product.title
        }
      ]
    }
  },
  data() {
    return {
      title: '',
      price: 0,
      product: {},
      randomProducts: [],
      loading: true
    }
  },
  components: {
    Cart,
    DonationItem
  },
  methods: {
    redirect(data) {
      this.$modal.show('redirect-modal', { data })
      setTimeout(() => {
        window.location.replace(data.redirect_url)
      }, 2000)
    },
    donate() {
      if (this.price < 1) {
        Swal.fire({
          title: 'Bağış tutarı minumum 1 TL olmalıdır.',
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Tamam'
        })
      } else {
        this.product.price = this.price
        this.$modal.show('basket-modal', { data: this.product })
      }
    }
  },
  created() {
    this.$http
      .get(`v2/product/${this.$route.params.id}`)
      .then((res) => {
        this.product = res.data
        this.price = res.data.price
        this.loading = false
      })
      .catch(() => {
        this.$router.push({ name: 'NotFound' })
      })

    this.$http
      .get('v2/product?order_by=random&per_page=3&parent_id=')
      .then((res) => {
        this.randomProducts = res.data.data
      })
  }
}
</script>

<style lang="scss" scoped>
</style>
